/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { ReactNode } from "react";
import Grid from "@mui/material/Grid";

export type ProductBoxGridProps = {
  items: [ReactNode] | [ReactNode, ReactNode];
};

export default function ProductBoxGrid({ items }: ProductBoxGridProps) {
  const noneNullableItems = items?.filter(item => item);
  const hasSecond = noneNullableItems?.length === 2;

  return (
    <Grid container spacing={{ xs: 4, md: 8 }}>
      <Grid size={{ xs: 12, md: hasSecond ? 8 : 12 }}>{noneNullableItems[0]}</Grid>
      {hasSecond && <Grid size={{ xs: 12, md: 4 }}>{noneNullableItems[1]}</Grid>}
    </Grid>
  );
}
